module.exports = __webpack_public_path__ + "static/media/video-thumb-large.b4ac892e.svg";